import i18n from "@/languages/index";

/**
 * 在非组件文件中使用 i18n 的工具函数
 * 保持与 useI18n() 相同的 API，可以在工具文件中使用
 * @returns { { t: Function, locale: Ref<string> } }
 */
export function useI18n() {
  return {
    t: (key: string, params?: Record<string, unknown> | unknown[]) => {
      return i18n.global.t(key, (params || {}) as any);
    },
    locale: i18n.global.locale
  };
}
